"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _userCanUpdateField = require("../../../../../schema/security/user-can-update-field");
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class DivisionFlags extends _react.Component {
  // *******************************************************************************
  // Render
  // *******************************************************************************

  render() {
    const division = this.props.division;
    const competitionID = this.props.competitionID;
    const user = this.props.user;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('isIncludedInEntryLimits', competitionID, user),
      type: "Checkbox",
      name: "isIncludedInEntryLimits",
      checked: division.isIncludedInEntryLimits,
      onChange: this.props.onChange,
      label: "Included in EntryLimits"
    }), /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('excludesEntriesInAnotherRace', competitionID, user),
      type: "Checkbox",
      name: "excludesEntriesInAnotherRace",
      checked: division.excludesEntriesInAnotherRace,
      onChange: this.props.onChange,
      label: "Excludes Entries In Another Race"
    }), /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('isFreeToEnter', competitionID, user),
      type: "Checkbox",
      name: "isFreeToEnter",
      checked: division.isFreeToEnter,
      onChange: this.props.onChange,
      label: "Free To Enter"
    }), /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: (0, _userCanUpdateField.userCanUpdateDivisionField)('isRestricted', competitionID, user),
      type: "Checkbox",
      name: "isRestricted",
      checked: division.isRestricted,
      onChange: this.props.onChange,
      label: "Restricted"
    }));
  }
  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(DivisionFlags, "partials", {
  Division: {
    id: true,
    isFreeToEnter: true,
    isIncludedInEntryLimits: true,
    excludesEntriesInAnotherRace: true,
    isRestricted: true,
    restriction: true
  }
});
var _default = exports.default = DivisionFlags;